const s = (e) => String(e).replace(/\B(?=(\d{3})+(?!\d))/g, " "), i = (e, t = 0) => String(parseFloat(e.toFixed(t))), n = ({ object: e = {}, value: t }) => {
  var r;
  return (r = Object.keys(e).find((o) => e[o] === t)) != null ? r : "";
}, c = (e) => e.replace(".", ","), a = (e = 0) => new Promise((t) => setTimeout(t, e)), l = ({ word: e = "час|часа|часов", number: t }) => {
  const r = e.split("|");
  return t % 10 === 1 && t % 100 !== 11 ? `${r[0]}` : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? `${r[1]}` : `${r[2]}`;
};
export {
  s as breakNumberToCategories,
  i as fixedNumber,
  n as getObjectKeyByValue,
  c as replaceDotByComma,
  a as wait,
  l as wordDeclension
};
